export function commissionDisbursementAuthorization() {
return [   //2024 Release 2025-04-21 19:29:28
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Property Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 104.48,
   left: 171.12,
   width: 376.56,
   height: 11.945
}
,
{
   page: 0,
   name: "date", 
   fontSize: 9,
   type: "date",
   top: 125.12,
   left: 171.12,
   width: 143.40,
   height: 11.945
}
,
{
   page: 0,
   name: "undefined", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 125.12,
   left: 465.24,
   width: 77.64,
   height: 11.945
}
,
{
   page: 0,
   name: "Closing Company", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 146.0,
   left: 171.12,
   width: 143.40,
   height: 11.945
}
,
{
   page: 0,
   name: "Closing Agent", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 167.64,
   left: 171.12,
   width: 143.40,
   height: 11.945
}
,
{
   page: 0,
   name: "1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 146.0,
   left: 467.88,
   width: 77.76,
   height: 11.945
}
,
{
   page: 0,
   name: "2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 166.88,
   left: 459.12,
   width: 89.64,
   height: 11.945
}
,
{
   page: 0,
   name: "Closing Agent Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 188.28,
   left: 171.12,
   width: 143.40,
   height: 11.945
}
,
{
   page: 0,
   name: "Agent Represents", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 188.28,
   left: 459.12,
   width: 89.64,
   height: 11.945
}
,
{
   page: 0,
   name: "Text1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 253.965,
   left: 66.1094,
   width: 487.2206,
   height: 14.145
}
,
{
   page: 0,
   name: "Text2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 270.765,
   left: 66.1094,
   width: 487.2206,
   height: 14.145
}
,
{
   page: 0,
   name: "Text3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 287.565,
   left: 66.1094,
   width: 487.2206,
   height: 14.145
}
,
{
   page: 0,
   name: "Text4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 304.365,
   left: 66.1094,
   width: 487.2206,
   height: 14.145
}
,
{
   page: 0,
   name: "Text5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 321.165,
   left: 66.1094,
   width: 487.2206,
   height: 14.145
}
,
{
   page: 0,
   name: "Text6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 337.965,
   left: 66.1094,
   width: 487.2206,
   height: 14.146
}
,
{
   page: 0,
   name: "Text7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 354.765,
   left: 66.1094,
   width: 487.2206,
   height: 14.146
}
,
{
   page: 0,
   name: "Text8", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 371.565,
   left: 66.1094,
   width: 487.2206,
   height: 14.146
}
,
{
   page: 0,
   name: "Text9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 388.365,
   left: 66.1094,
   width: 487.2206,
   height: 14.146
}
,
{
   page: 0,
   name: "Text10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 405.165,
   left: 66.1094,
   width: 487.2206,
   height: 14.146
}
,
{
   page: 0,
   name: "Text11", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 445.878,
   left: 59.5639,
   width: 506.5951,
   height: 257.1122
}
,
{
   page: 0,
   name: "Text12", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 206.445,
   left: 63.3603,
   width: 101.3017,
   height: 11.945
}
,
{
   page: 0,
   name: "Text13", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 206.445,
   left: 171.12,
   width: 143.40,
   height: 11.945
}
,
{
   page: 0,
   name: "Text14", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 206.445,
   left: 329.238,
   width: 118.582,
   height: 11.945
}
,
{
   page: 0,
   name: "Text15", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 206.445,
   left: 459.12,
   width: 89.64,
   height: 11.945
}
,
{
   page: 0,
   name: "Text16", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 739.3719,
   left: 63.3598,
   width: 223.3092,
   height: 22.5237
}
] }
